import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { FaFolderOpen } from "react-icons/fa";
import axios from "axios";

import { montarIcon } from "../../../../../../../shared/utils/Drive/file/getFileIcon";

import styles from "./Ficheiros.module.scss";

export default function Ficheiros({ cursoId }) {
    const [pastas, setPastas] = useState([]);

    const [dataSource, setDataSource] = useState([]);
    const [breadcrumb, setBreadcrumb] = useState([]);

    const columns = [
        {
            title: "Nome",
            dataIndex: "nome",
            key: "nome",
            render: (text, record) => {
                if (record.tipo === "pasta") {
                    return (
                        <span
                            onClick={() => handlePastaAtualId(record.id)}
                            className={styles.pasta}
                        >
                            <FaFolderOpen size={20} color={"#f5ca5a"} /> {text}
                        </span>
                    );
                }
                return (
                    <a
                        className={styles.ficheiro}
                        href={record.ficheiro}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={e => e.stopPropagation()}
                    >
                        {montarIcon(record)} {text}
                    </a>
                );
            }
        },
        {
            title: "Data",
            dataIndex: "dt_criado",
            render: (text, record) => (text ? text.split("T")[0] : "-")
        }
    ];

    const handlePastaAtualId = id => {
        //Todos Ficheiros
        if (id === null) {
            setDataSource(
                pastas
                    .filter(p => p.nivel === 1)
                    .map(p => ({
                        key: p.id,
                        id: p.id,
                        nome: p.nome,
                        tipo: "pasta"
                    }))
            );

            setBreadcrumb([{ id: null, nome: "Todos Ficheiros" }]);

            return;
        }

        const pastasMostrar = pastas
            .filter(f => f.pastaPai === id)
            .map(f => ({
                key: f.id,
                id: f.id,
                nome: f.nome,
                tipo: "pasta",
                dt_criado: ""
            }));

        const pastaAtual = pastas.find(f => f.id === id);

        const ficheiros = (pastaAtual?.ficheiros || []).map(f => ({
            key: f.id,
            id: f.id,
            nome: f.nome,
            tipo: "ficheiro",
            dt_criado: f.dt_criado,
            ficheiro: f.ficheiro,
            extensao: f.extensao
        }));

        setDataSource([...pastasMostrar, ...ficheiros]);

        if (pastaAtual?.niveis) {
            const caminho = pastaAtual.niveis
                .split(".")
                .map(n => parseInt(n))
                .map(nivelId => {
                    const pasta = pastas.find(p => p.id === nivelId);
                    return pasta ? { id: pasta.id, nome: pasta.nome } : null;
                })
                .filter(Boolean);

            caminho.unshift({ id: null, nome: "Todos Ficheiros" });
            // guarda no state se quiseres usar no UI
            setBreadcrumb(caminho);
        }
    };

    useEffect(() => {
        if (cursoId) {
            axios({
                method: "GET",
                url: `/api/curso-fichs/listar-area-aluno?cursoId=${cursoId}`
            })
                .then(response => {
                    setPastas(response.data.pastas);

                    setDataSource(
                        response.data.pastas
                            .filter(p => p.nivel == 1)
                            .map(p => {
                                return {
                                    key: p.id,
                                    id: p.id,
                                    nome: p.nome,
                                    tipo: "pasta"
                                };
                            })
                    );

                    setBreadcrumb([{ id: null, nome: "Todos Ficheiros" }]);
                })
                .catch(() => {});
        }
    }, [cursoId]);

    return (
        <div className={styles.drive}>
            <div className={styles.breadcrumb}>
                {breadcrumb.map((item, index) => (
                    <span key={item.id}>
                        <span className={styles.itemBreadcrumb} onClick={() => handlePastaAtualId(item.id)}>
                            {item.nome}
                        </span>

                        {index < breadcrumb.length - 1 && " / "}
                    </span>
                ))}
            </div>
            {dataSource && <Table className={styles.tabela} dataSource={dataSource} columns={columns} />}
        </div>
    );
}
